module.exports = require('./dist/anychart-bundle.min.js');



//////////////////
// WEBPACK FOOTER
// ./~/anychart/index.js
// module id = 273
// module chunks = 0